import { useNavigate } from 'react-router-dom';
import { Zap, Newspaper, FilePlus2, CalendarPlus, Megaphone, ImagePlus } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface Action {
	label: string;
	icon: LucideIcon;
	route: string;
	colorClasses: string;
}

const ACTIONS: Action[] = [
	{
		label: 'Create New Article',
		icon: Newspaper,
		route: '/admin/press-release/new',
		colorClasses: 'border-red-300 bg-red-50 text-red-600 hover:bg-red-100',
	},
	{
		label: 'Add New Page',
		icon: FilePlus2,
		route: '/admin/content',
		colorClasses: 'border-green-400 bg-green-50 text-green-700 hover:bg-green-100',
	},
	{
		label: 'Create New Event',
		icon: CalendarPlus,
		route: '/admin/events/add',
		colorClasses: 'border-amber-400 bg-amber-50 text-amber-700 hover:bg-amber-100',
	},
	{
		label: 'Post Announcement',
		icon: Megaphone,
		route: '/admin/announcement',
		colorClasses: 'border-purple-400 bg-purple-50 text-purple-700 hover:bg-purple-100',
	},
	{
		label: 'Upload Media',
		icon: ImagePlus,
		route: '/admin/photo-gallery',
		colorClasses: 'border-teal-400 bg-teal-50 text-teal-700 hover:bg-teal-100',
	},
];

const QuickActions = () => {
	const navigate = useNavigate();

	return (
		<div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
			<h2 className="mb-4 flex items-center gap-2 text-sm font-semibold text-gray-800">
				<Zap className="h-4 w-4 fill-yellow-400 text-yellow-400" />
				Quick Actions
			</h2>
			<ul className="space-y-2.5 list-none">
				{ACTIONS.map(({ label, icon: Icon, route, colorClasses }) => (
					<li key={label}>
						<button
							type="button"
							onClick={() => navigate(route)}
							className={`flex w-full items-center gap-3 rounded-lg border px-4 py-2.5 text-sm font-medium transition-colors ${colorClasses}`}
						>
							<Icon className="h-4 w-4 shrink-0" />
							{label}
						</button>
					</li>
				))}
			</ul>
		</div>
	);
};

export default QuickActions;
